import { AfterViewInit, Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { sanitizeInternalUrl } from '../utils/url-sanitizer.util';

@Directive({
  selector: '[routerLinkDetector]',
  standalone: true
})
export class RouterLinkDetectorDirective implements AfterViewInit {
  constructor(
    private element: ElementRef,
    private router: Router,
    private renderer: Renderer2
  ) { }

  ngAfterViewInit(): void {
    // Sanitize the href attribute when the directive initializes
    // This handles cases where static hrefs in HTML content need sanitization
    let linkUrl = this.element.nativeElement.getAttribute('href');
    if (!linkUrl) return;

    const target = this.element.nativeElement.getAttribute('target');
    const isExternalLink = linkUrl.startsWith('http') ||
      linkUrl.toLowerCase().startsWith('mailto:') ||
      linkUrl.toLowerCase().startsWith('tel:') ||
      linkUrl.toLowerCase().startsWith('/media/') ||
      target;

    if (!isExternalLink) {
      // Sanitize internal URL by removing /he/ and trailing slashes
      const sanitizedUrl = sanitizeInternalUrl(linkUrl);
      if (sanitizedUrl !== linkUrl) {
        this.renderer.setAttribute(this.element.nativeElement, 'href', sanitizedUrl);
      }
    }
  }

  @HostListener('click', ['$event']) onClick($event: PointerEvent) {
    let linkUrl = this.element.nativeElement.getAttribute('href');
    let target = this.element.nativeElement.getAttribute('target');
    if (!linkUrl) {
      $event.preventDefault();
      return;
    }

    const isExternalLink = linkUrl.startsWith('http') ||
      linkUrl.toLowerCase().startsWith('mailto:') ||
      linkUrl.toLowerCase().startsWith('tel:') ||
      linkUrl.toLowerCase().startsWith('/media/') ||
      target;

    if (!isExternalLink) {
      $event.preventDefault();
      const [path, queryString] = linkUrl.split('?');

      const queryParams = queryString
        ? queryString.split('&').reduce(
          (acc: any, param: any) => {
            const [key, value] = param.split('=');
            acc[key] = value;
            return acc;
          },
          {} as Record<string, string>
        )
        : {};
      const [route, fragment] = path.split('#');
      if (fragment)
        this.router.navigate([route], { fragment });
      else
        this.router.navigate([path], { queryParams });
    }
  }
}
